import { StockType } from "@/src/utils/stockType";

export const SCOPE_MAP = {
  PORTFOLIO_CHAT_REC: "PORTFOLIO_CHAT_REC",
  AGENT_SEARCH: "AGENT_SEARCH",
  STOCK_CHAT: "STOCK_CHAT",
  TOKEN_CHAT: "TOKEN_CHAT",
  TOKEN_PORTFOLIO_SEARCH: "TOKEN_PORTFOLIO_SEARCH",
  STOCK_PORTFOLIO_SEARCH: "STOCK_PORTFOLIO_SEARCH",
  TOKEN_CHAT_REC: "TOKEN_CHAT_REC",
  STOCK_CHAT_REC: "STOCK_CHAT_REC",
  HK_STOCK_CHAT_REC: "HK_STOCK_CHAT_REC",
  TOKEN_DETAIL_CHAT_REC: "TOKEN_DETAIL_CHAT_REC",
  STOCK_DETAIL_CHAT_REC: "STOCK_DETAIL_CHAT_REC",
  TOKEN_NEWS_PERSONAL: "TOKEN_NEWS_PERSONAL",
  STOCK_NEWS_PERSONAL: "STOCK_NEWS_PERSONAL",
  TOKEN_PORTFOLIO: "TOKEN_PORTFOLIO",
  TOKEN_PERSONAL: "TOKEN_PERSONAL",
  STOCK_PORTFOLIO: "STOCK_PORTFOLIO",
  STOCK_PERSONAL: "STOCK_PERSONAL",
  TOKEN_MARKET_SUMMARY: "TOKEN_MARKET_SUMMARY",
  STOCK_MARKET_SUMMARY: "STOCK_MARKET_SUMMARY",
} as const;

export const HOME_RECOMMEND_SCOPE_MAP = {
  crypto: SCOPE_MAP.TOKEN_CHAT_REC,
  stock: {
    US: SCOPE_MAP.STOCK_CHAT_REC,
    HK: SCOPE_MAP.HK_STOCK_CHAT_REC,
  },
} as const;

export const DETAIL_RECOMMEND_SCOPE_MAP = {
  crypto: SCOPE_MAP.TOKEN_DETAIL_CHAT_REC,
  stock: SCOPE_MAP.STOCK_DETAIL_CHAT_REC,
} as const;

export type HomeRecommendType = keyof typeof HOME_RECOMMEND_SCOPE_MAP;
export type DetailRecommendType = keyof typeof DETAIL_RECOMMEND_SCOPE_MAP;

export const buildRecommendScopes = (
  type: HomeRecommendType,
  limit = 20,
  stockType?: StockType,
) => ({
  [`scopes[${type === "crypto" ? HOME_RECOMMEND_SCOPE_MAP[type] : stockType === "HK" ? HOME_RECOMMEND_SCOPE_MAP.stock.HK : HOME_RECOMMEND_SCOPE_MAP.stock.US}]`]:
    limit,
});

export const buildDetailRecommendScopes = (
  type: DetailRecommendType,
  limit = 20,
) => ({
  [`scopes[${DETAIL_RECOMMEND_SCOPE_MAP[type]}]`]: limit,
});
